import React from "react";
import { TOUCH_FEEDBACK_STYLE } from "../../../../constants/secondaryCamera";

// Shared by both slides' primary buttons — `busy` only swaps the disabled cursor.
const WizardPrimaryButton = ({ onClick, disabled, busy, children }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={TOUCH_FEEDBACK_STYLE}
    className={`flex-1 px-6 py-3 rounded-full font-medium text-white transition-transform active:scale-95 ${
      disabled
        ? `bg-gray-600/50 ${busy ? "cursor-wait" : "cursor-not-allowed"}`
        : "bg-gradient-to-r from-pink-500 to-blue-500 hover:from-pink-600 hover:to-blue-600 active:from-pink-600 active:to-blue-600"
    }`}
  >
    {children}
  </button>
);

export default WizardPrimaryButton;
